var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("my_input_number", {
        staticClass: "slider-input",
        attrs: {
          titleWidth: "0",
          value: _vm.result,
          min: 0,
          max: 360,
          size: "medium",
          "num-type": _vm.numType,
          step: _vm.step,
          symbol: "°",
          width: "56",
          precision: 0,
        },
        on: {
          "update:value": function ($event) {
            _vm.result = $event
          },
          change: _vm.change_input,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }